import { makeAutoObservable } from 'mobx'
import type { ChatbotKnowledgeBase } from 'entities/Chatbot'
import { AgentKnowledgeBaseStore } from 'pages/chatbot/ui/AgentKnowledgeBase/store/AgentKnowledgeBaseStore'

export class KnowledgeBaseSectionStore {
  readonly agentKnowledgeBaseStore = new AgentKnowledgeBaseStore()
  documents: number[] = []

  constructor(private readonly _knowledgeBase: ChatbotKnowledgeBase) {
    makeAutoObservable(this)
  }

  get useKnowledgeBase() {
    return this._knowledgeBase.useKnowledgeBase
  }

  setUseKnowledgeBase = (value: boolean) => {
    this._knowledgeBase.setUseKnowledgeBase(value)

    if (!value) {
      this.setDocuments([])
      this.agentKnowledgeBaseStore.agentDocumentsStore.deselectAllDocuments()
    }
  }

  setDocuments = (documents: number[]) => {
    this.documents = documents
  }
}
